import { Component, HostListener } from '@angular/core';
import { NavigationEnd, Router, } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { MetaDataService } from './services/metadata.service';
import { EventsService } from './services/events.service';
import { TweenMax, Power4 } from 'gsap';
declare var window;
import * as skrollr from 'skrollr';
import * as $ from 'jquery';

const NAV_OFFSET = 200;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  pageClass: string;
  scrollMax: number;
  anchor: string;
  desktop: boolean;
  routeChangeType: 'intro' | 'overlay';
  initialLoad = false;
  hideContent = true;
  $window;
  _skrollr;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.desktop = window.innerWidth > 767 ? true : false;
    this.checkSkrollr();
  }

  @HostListener('window:scroll', ['$event']) onScroll() {
    this.events.broadcast('window:scroll');
  }

  constructor(
    private router: Router,
    private location: PlatformLocation,
    private mds: MetaDataService,
    private events: EventsService
  ) {
    this.events.on('route:change', ({ path, intro }) => {
      this.anchor = path;
      this.routeChangeType = intro ? 'intro' : 'overlay';

      // Fade out intro immediately
      if (intro) {
        $('.video-intro .fallback').addClass('hide');
      }

      this.routeChange();
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });

    // Deep linking functionality
    if (window.location.pathname !== '/') {
      this.anchor = window.location.pathname.replace('/', '');
      this.routeChange();
    }
  }

  routeChange() {
    this.location.replaceState({}, this.anchor, '/' + this.anchor);

    // Add outer page class
    this.setPageClass(this.anchor);

    // Anchor link scrolls
    this.pageAnchorLinkScroll();
  }

  setPageClass(slug: string) {
    window.onresize = this.onResize(event);
    if (slug === '/') {
      this.pageClass = 'home-page';
    } else {
      this.pageClass = `${slug.replace(/\//g, '')}-page`;
    }
  }

  pageAnchorLinkScroll() {
    // IMPORTANT: Basically crucial to set a timeout here or else the browser cant grab the correct position
    // That's because a lot of the elements use ngIf to check if theres content before displaying
    setTimeout(
      () => {
        const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
        const body = isChrome ? document.documentElement : document.body;
        const distance = this.getAnchorOffset();
        this.initialLoad = true;

        if (distance && distance > 0 && this.desktop) {
          TweenMax.fromTo(
            body,
            1,
            {
              scrollTop: $(window).scrollTop(),
              ease: Power4.easeInOut
            },
            {
              scrollTop: distance,
              ease: Power4.easeInOut,
              onComplete: this.handleIntroComplete
            }
          );
        } else {
          $(window).scrollTop(distance);
          this.handleIntroComplete();
        }
      }, ((this.routeChangeType !== 'intro' && this.routeChangeType !== 'overlay') ? 2000 : 500));
  }

  getAnchorOffset() {
    const offset = this.desktop ? NAV_OFFSET : NAV_OFFSET / 2;
    const $section = $(`section[class^="home-section-${this.anchor}"]`);
    $(`section[class^="home-section-${this.anchor}"]`).focus().attr('tabindex', -1);
    return $section && $section.length ? $section.offset().top - offset : 0;
  }

  // Handles the finalization of the intro
  // Removes the video from the DOM and adjusts accordingly
  handleIntroComplete = () => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    $(`section[class^="home-section"]`).addClass('inview');
    $('[data-intro]').css({ opacity: 0, pointerEvents: 'none' });
    $('[data-intro] *').css({ opacity: 0, pointerEvents: 'none' });
    $('.video-intro').remove();
    this.hideContent = false;

    // IMPORTANT: Absolutely required for Safari
    // I almost think Chrome is smart enough to adjust window.scrollTop if a DOM element was removed
    if (this.desktop) {
      if (this.routeChangeType === 'intro' && isSafari || ((this.anchor === 'about' || this.anchor === 'events') && this.routeChangeType === 'intro' && !isSafari)) {
        window.scrollTo(0, $(window).scrollTop() - window.innerHeight);
      }
    } else {
      setTimeout(() => {
        window.scrollTo(0, this.getAnchorOffset());
      }, 100);
    }
  }

  handleSkipNav($e) {
    $e.preventDefault();
    $('#maincontent').focus();
  }

  checkSkrollr() {
    const width = window.innerWidth;

    // Handle skrollr on resize
    if (this._skrollr && width <= 768) {
      this._skrollr.destroy();
      this._skrollr = null;
    } else if (!this._skrollr && width > 768) {
      // Need to wait for page items to be instantiated
      setTimeout(() => {
        this._skrollr = skrollr.init({ forceHeight: false });
      }, 1000);
    }
  }
}
